import React from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import DualLensPipelineSteps from "./DualLensPipelineSteps";

export default function DualLensProcessing({ url, statusLabel, progress }) {
	const navigate = useNavigate();
	const label = statusLabel || "Preparing your Dual Lens comparison";

	return (
		<div className="contentBlock ai-visibility-dashboard dual-lens dual-lens-view">
			<div className="dual-lens__header">
				<div className="dual-lens__header-left">
					<button
						type="button"
						className="dual-lens__back"
						onClick={() => navigate("/aivisibility/dual-lens")}
					>
						<i className="fas fa-arrow-left me-2" />
						Dual Lens View
					</button>
					{url && (
						<a
							href={url}
							target="_blank"
							rel="noopener noreferrer"
							className="dual-lens__header-url"
						>
							{url}
						</a>
					)}
				</div>
				{statusLabel && (
					<span className="dual-lens__status-badge dual-lens__status-badge--processing">
						{statusLabel}
					</span>
				)}
			</div>

			<div className="dual-lens__processing">
				<Spinner color="primary" className="mb-3" />
				<p className="dual-lens__processing-title mb-1">{label}…</p>
				<p className="dual-lens__processing-subtitle text-muted mb-0">
					This may take a minute while we fetch the page through each lens.
				</p>
			</div>
			<DualLensPipelineSteps statusLabel={statusLabel} progress={progress} />
		</div>
	);
}
